import { render, staticRenderFns } from "./Wp_mini_member_fans_model.vue?vue&type=template&id=6ea158be&scoped=true&"
import script from "./Wp_mini_member_fans_model.vue?vue&type=script&lang=js&"
export * from "./Wp_mini_member_fans_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea158be",
  null
  
)

export default component.exports